import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-aurea-mission',
  templateUrl: './aurea-mission.component.html',
  styleUrls: ['./aurea-mission.component.scss']
})
export class AureaMissionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
